import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  public errorMessage: BehaviorSubject<any> = new BehaviorSubject('');

  constructor() { }
}
